var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechatPage"},[_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v("正在登录中，请稍候...")])])
}]

export { render, staticRenderFns }